import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { MdwPhoneNumberInput } from '@spaces-ui/meadow/components/phone-number';

import { Sample } from '../../components';

@Component({
  selector: 'app-phone-numbers',
  imports: [Sample, MdwPhoneNumberInput, ReactiveFormsModule],
  templateUrl: './phone-numbers.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './phone-numbers.scss',
})
export class PhoneNumbers {
  public formGroup = new FormGroup({
    requiredPhoneNumber: new FormControl(undefined),
    optionalPhoneNumber: new FormControl(undefined),
    disabledPhoneNumber: new FormControl({ value: undefined, disabled: true }),
  });
}
